module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.eot?8a67040660444e8d8ee82a406d580d8f";